import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/zhuyezhiye.png'
import _imports_1 from '@/assets/icon/zhuyegongsi.png'
import _imports_2 from '@/assets/icon/zhuyingchanpin.png'


const _withScopeId = n => (_pushScopeId("data-v-db72fba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "attention"
}
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = { class: "name" }
const _hoisted_4 = {
  key: 0,
  class: "username"
}
const _hoisted_5 = {
  key: 1,
  class: "username"
}
const _hoisted_6 = {
  key: 2,
  class: "infor"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "zhiye"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "gongsi"
}
const _hoisted_9 = {
  key: 3,
  class: "infor"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "zhiye"
}, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "关注TA", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已关注", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 2,
  class: "all1"
}
const _hoisted_20 = { class: "all" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lack = _resolveComponent("Lack")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_page_show = _resolveComponent("page-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.getInformation.data.list == 0 && _ctx.getInformation.data.list.length == 0)
      ? (_openBlock(), _createBlock(_component_Lack, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.getInformation.data.list && _ctx.getInformation.data.list.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInformation.data.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "user",
              key: index
            }, [
              _createVNode(_component_router_link, {
                to: {
          name: 'personalcenter',
          params: {
            userid: item.id,
          },
        }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.getImgUrl(item.portrait),
                    alt: "",
                    onClick: ($event: any) => (_ctx.transmitData(item.portrait))
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", _hoisted_3, [
                (item.company_id == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.username), 1))
                  : _createCommentVNode("", true),
                (item.company_id != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.company), 1))
                  : _createCommentVNode("", true),
                (item.company_id == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("p", null, _toDisplayString(item.vocation ? item.vocation : "职业暂未填写"), 1),
                      (item.company != '')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, _toDisplayString(item.company), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.company_id != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("p", null, _toDisplayString(item.products), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (!item.isselect)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "focus",
                    onClick: ($event: any) => (_ctx.dofollow(index, 0))
                  }, _hoisted_14, 8, _hoisted_11))
                : _createCommentVNode("", true),
              (item.isselect)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["focus", { focus1: _ctx.attention }]),
                    onClick: ($event: any) => (_ctx.dofollow(index, 1))
                  }, _hoisted_18, 10, _hoisted_15))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.getInformation.data.list.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, " 共" + _toDisplayString(_ctx.total) + "条,每页显示10条,第" + _toDisplayString(_ctx.fanslist.pageIndex) + "/" + _toDisplayString(Math.ceil(_ctx.total / 20)) + "页 ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.getInformation.data.list.length > 1)
      ? (_openBlock(), _createBlock(_component_page_show, {
          key: 3,
          total: _ctx.total,
          pageSize: 20,
          onHandleCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "onHandleCurrentChange"]))
      : _createCommentVNode("", true)
  ], 64))
}